import { NotifyRepository } from 'application/repositories/NotifyRepository';
import { PostPutDeleteBaseResponse } from 'domain/entities/CommonEntity';
import { NotifyResponse, ParamsNotify, SettingNotifyData } from 'domain/entities/NotifyEntity';
import axiosConfig from 'infrastructure/config/axios';

export class NotifyAPI implements NotifyRepository {
    async getListNotifySystem(params: ParamsNotify): Promise<NotifyResponse> {
        const API_URL = `/notification/list-system-notices`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }

    async getListNotify(params: ParamsNotify): Promise<NotifyResponse> {
        const API_URL = `/notification/list-operation-notices`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }
    async updateSystemNotice(params: { id: number }): Promise<PostPutDeleteBaseResponse> {
        const API_URL = `/notification/update-system-notice/${params.id}`;
        const response = await axiosConfig.getAxiosConfig().put(API_URL);
        return response.data;
    }
    async updateOperationNotice(params: { id: number }): Promise<PostPutDeleteBaseResponse> {
        const API_URL = `/notification/update-operation-notice/${params.id}`;
        const response = await axiosConfig.getAxiosConfig().put(API_URL);
        return response.data;
    }
    async settingNotifyForUser(notifyData: SettingNotifyData): Promise<PostPutDeleteBaseResponse> {
        const API_URL = `/mypage/setting-notify?member_id=${notifyData.memberId}&setting_notify_system=${notifyData.notifyStatus[0]}&setting_notify_transaction=${notifyData.notifyStatus[1]}&setting_notify_member=${notifyData.notifyStatus[2]}`;
        const response = await axiosConfig.getAxiosConfig().put(API_URL);
        return response.data;
    }
    async countUnreadNotify(): Promise<any> {
        const API_URL = `/notification/unread-notices`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }
}
